import React, { Component } from 'react';
import { ListTabButton } from '../../list-tab/list-tab-button.component';
import ButtonIcon from '../../../button';

class DetailContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
        };
    }

    componentDidMount() {
        this.setState({ selectedIndex: this.props.urlIndex });
    }

    FilterIndex = (tabIndex) => {
        const {renderTabContent} = this.props;
        this.setState({ selectedIndex: tabIndex });
        renderTabContent(tabIndex)
    }
    handlecloseForm = () =>{
        const {handleClose} = this.props;
        handleClose();
    }

    render() {
        const {children, listTab, showBackButton} = this.props;
        return (
            <div className="layout-container">
                {showBackButton? <ButtonIcon onClick={this.handlecloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" /> : null}
                {listTab? <ListTabButton listData={listTab} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex} /> 
                : null}
                <div  className={`${this?.props?.isMultiContainer? "" : "details-container"} date-picker-main-container`}>
                    {children}
                </div>
            </div>
        );
    }
}



export default DetailContainer;